import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../domain/services/api.service';
import { ProviderSearch } from '../models';
import { Provider } from './../models';

export type ProvidersSearchResult = {
    formattedAddress: string;
    providers: Provider[];
};

@Injectable({
    providedIn: 'root'
})
export class ProviderService {
    constructor(private apiService: ApiService) {}

    /** GET providers from the server */
    getProviders(
        searchParams: ProviderSearch
    ): Observable<ProvidersSearchResult> {
        let httpParams = new HttpParams().set(
            'clientId',
            runtimeConfig.clientId
        );
        if (searchParams.searchText)
            httpParams = httpParams.append('search', searchParams.searchText);
        if (searchParams.programIds) {
            searchParams.programIds.forEach((x) => {
                httpParams = httpParams.append('programIds', x.toString());
            });
        }
        if (searchParams.address)
            httpParams = httpParams.append('address', searchParams.address);
        if (searchParams.distance)
            httpParams = httpParams.append('distance', searchParams.distance);
        if (searchParams.sort)
            httpParams = httpParams.append('sort', searchParams.sort);
        return this.apiService.get('/providers', httpParams);
    }
}
